import { useEffect, useState } from 'react'
import { platformService } from '@/services/platformService'
import type { Tenant } from '@/types/api.types'

export default function PlatformDashboardPage() {
    const [tenants, setTenants] = useState<Tenant[]>([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        platformService.listTenants()
            .then(setTenants)
            .catch(() => setTenants([]))
            .finally(() => setLoading(false))
    }, [])

    const count = (status: string) => tenants.filter((t) => t.status === status).length
    const cards = [
        { label: 'Tenants totales', value: tenants.length },
        { label: 'Activos', value: count('ACTIVE') },
        { label: 'En trial', value: count('TRIAL') },
        { label: 'Suspendidos', value: count('SUSPENDED') },
    ]

    return (
        <div>
            <h1 className="mb-6 text-2xl font-semibold">Dashboard</h1>
            {loading ? (
                <div className="text-slate-400">Cargando…</div>
            ) : (
                <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
                    {cards.map((c) => (
                        <div key={c.label} className="rounded-xl border border-slate-800 bg-slate-800/50 p-5">
                            <div className="text-3xl font-semibold">{c.value}</div>
                            <div className="mt-1 text-sm text-slate-400">{c.label}</div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
